import MessageHeader from "./MessageHeader";

const MessageFile = ({
  fromClient,
  messageSentTime,
  userData,
  fileName,
  size,
}: {
  fromClient: boolean;
  messageSentTime: number;
  userData: any;
  fileName: string;
  size: number;
}) => {
  return (
    <div className={`message ${fromClient ? "right" : "left"}`}>
      <MessageHeader
        fromClient={fromClient}
        messageSentTime={messageSentTime}
        userData={userData}
      />
      <div className="message-file">
        <div className="message-file__main">
          <h2 className="subtitle-5">{fileName}</h2>
          <span>{size} KB</span>
        </div>

        <h5>Download</h5>
      </div>
    </div>
  );
};

export default MessageFile;
